import React, { Component } from "react";import {
params,
  loading,
  tokens,
  Modal,
  required,
  float
} from "./CustomComponent.js";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { 
    };
  }
  componentDidMount = async () => {
    loading(false); 
  }; 
  render() {
    const { } = this.state;
    return (
      <div> 
      <div
        className="w-100 px-3 py-1 bg-dark text-white" 
      >
        <div className="row">
          <div className="col-12 text-center d-flex justify-content-between px-5">
            <small>@2025 "Zenith" All rights reserved. v.{global.version}</small>
            <small><a className="text-decoration-none text-light" href="/policy-privacy" target="_blank">privacy & policy</a></small>
          </div>
        </div>
      </div>
      </div>
    );
  }
}
